import React, { useMemo } from 'react';
import { ItemRendererContainer } from '../../styles';
import statusColorMap from 'constants/statusColorMap';
import colors from 'constants/colors';

const stringToSeed = (str) => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = (hash * 31 + str.charCodeAt(i)) >>> 0;
  }
  return hash;
};

const seededRandom = (seed) => {
  return function () {
    seed = (seed * 1664525 + 1013904223) >>> 0;
    return seed / 0xFFFFFFFF;
  };
};

const randomHexFromString = (str) => {
  if (!str) return { value1: 0x1F330, value2: 0x1F330 };

  const seed = stringToSeed(str);
  const rng = seededRandom(seed);
  const rangeChoice = rng();

  let value1, value2;
  if (rangeChoice < 0.5) {
    const base = 0x1F330;
    const range = 0x1F380 - base;
    value1 = base + Math.floor(rng() * range);
    value2 = base + Math.floor(rng() * range);
  } else {
    const base = 0x1F400;
    const range = 0x1F440 - base;
    value1 = base + Math.floor(rng() * range);
    value2 = base + Math.floor(rng() * range);
  }

  return { value1, value2 };
};

const ItemRenderer = ({ item, itemContext, getItemProps }) => {
  const isSelected = itemContext.selected;
  const { groupId, status, title: name } = item;

  const color = statusColorMap[status] || statusColorMap.default;

  const hexValue = useMemo(
    () => randomHexFromString(groupId),
    [groupId]
  );

  // Pull out key and rest before applying to <div>
  const { key, ...restItemProps } = getItemProps({
    style: {
      background: color,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      borderRadius: "15px",
      border: isSelected ? `2px solid ${colors.white}` : "none",
    },
  });

  return (
    <div key={key} {...restItemProps}>
      <ItemRendererContainer>
        {String.fromCodePoint(hexValue.value1)}
        {String.fromCodePoint(hexValue.value2)} {name}
      </ItemRendererContainer>
    </div>
  );
};

export default ItemRenderer;